
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/straps/[material]",
      function () {
        return require("private-next-pages/[lang]/straps/[material].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/straps/[material]"])
      });
    }
  